import SchoolTransportationList from './_components/SchoolTransportationList';

const SchoolTransportationPage = () => {
  return <SchoolTransportationList />;
};

export default SchoolTransportationPage;
